import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ReactCountryFlag from "react-country-flag";
import { Languages, ChevronDown } from "lucide-react";

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const languages = [
    { code: "en", name: "", country: "US" },
    { code: "fr", name: "", country: "FR" },
  ];

  const currentLang =
    languages.find((lang) => lang.code === i18n.language) || languages[0];
  const otherLanguages = languages.filter(
    (lang) => lang.code !== currentLang.code
  );

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen((open) => !open)}
        className="flex items-center gap-2 p-2 rounded-md transition-colors"
        aria-label={`Current language: ${currentLang.name}. Click to change language.`}
      >
        <Languages size={16} />
        <ReactCountryFlag
          countryCode={currentLang.country}
          svg
          style={{ width: "1.5em", height: "1.5em" }}
        />
        <ChevronDown size={16} />
      </button>
      {isOpen && (
        <div className="absolute rounded-lg  z-10">
          {otherLanguages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => changeLanguage(lang.code)}
              className="flex flex-col items-center w-full p-2 ml-4 hover:bg-gray-200 transition-colors"
              aria-label={`Switch language to ${lang.name}`}
            >
              <ReactCountryFlag
                countryCode={lang.country}
                svg
                style={{ width: "1.5em", height: "1.5em" }}
              />
              <span className="mt-1 text-sm">{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default LanguageSwitcher;
